'use client'

import ExportedImage from 'next-image-export-optimizer'
import Link from 'next/link'
import { useState } from 'react'

import { Pagination } from '@/components/atoms/pagination'
import { Button } from '@/components/atoms/ui/button'

const ITEMS_PER_PAGE = 5

interface Article {
  data: Search[]
}

// const sortArticlesByDate = (articles: Article['data']) => {
//   return articles.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
// }

export const SearchArticle = ({ data }: Article) => {
  const [activePage, setActivePage] = useState(0)

  // const sortedArticles = useMemo(() => sortArticlesByDate(data), [data])

  const startIndex = activePage * ITEMS_PER_PAGE
  const visibleArticles = data.slice(startIndex, startIndex + ITEMS_PER_PAGE)
  const totalPages = Math.ceil(data.length / ITEMS_PER_PAGE)

  return (
    <article className="flex flex-col gap-4">
      {visibleArticles.map((item, index) => (
        <Link key={index} href={`/${encodeURIComponent(item.uid)}`}>
          <figure className="flex items-center w-full h-full gap-4 overflow-hidden rounded-xl group">
            <div className={'w-3/12 h-[98px] relative overflow-hidden rounded-xl'}>
              <ExportedImage
                src={item.image.file.url ? 'https:' + item.image.file.url : '/static/images/dummy-article.png'}
                alt={'Gambar artikel'}
                fill
                className={'object-cover transition-all duration-300 group-hover:scale-105 group-hover:opacity-80'}
              />
            </div>
            <figcaption className="flex flex-col justify-between w-9/12 h-full py-3 space-y-4 transition-all bg-white group-hover:text-primary-blue">
              <div className="space-y-1">
                <span className="text-xs font-medium text-primary-blue line-clamp-1">{item.category}</span>
                <h3 className="font-bold sm:text-lg line-clamp-2">{item.title}</h3>
              </div>
              <Button className="hidden w-[140px] text-sm font-semibold text-white">Selengkapnya</Button>
            </figcaption>
          </figure>
        </Link>
      ))}
      <div className="flex justify-center">
        <Pagination totalPage={totalPages} activeIndex={activePage} onChange={setActivePage} />
      </div>
    </article>
  )
}
